export class SnackBarProps {
  constructor(message, severity) {
    this.message = message;
    this.severity = severity;
  }
}
